
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import dynamic from "next/dynamic";
import { MFEStyleSheetManager } from "@/components/MFEStyleSheetManager";

const CreateAccount = dynamic(import("createAccount/CreateAccount"), {
  ssr: false,
});

export default function CreateAccountMFEPage() {
  return (
    <MFEStyleSheetManager>
      <CreateAccount />
    </MFEStyleSheetManager>
  );
}
